import { ChevronDown } from "lucide-react";
import type { SectionRole } from "@/lib/domain/site-content";
import styles from "./section-role-field.module.css";

export function SectionRoleField({ value, onChange, label = "Bölüm rolü" }: {
  value: SectionRole;
  onChange: (value: SectionRole) => void;
  label?: string;
}) {
  return <label className={styles.field}>
    <span className="ui-label">{label}</span>
    <span className={styles.selectWrap}>
      <select aria-label={label} className="ui-input" value={value} onChange={(event) => onChange(event.target.value as SectionRole)}>
        <option value="discovery">Keşfetme · Ana</option>
        <option value="explanation">Açıklama · Ana</option>
        <option value="action">Aksiyon · Vurgu</option>
        <option value="reading">Okuma · Ana</option>
      </select>
      <ChevronDown size={16} aria-hidden="true"/>
    </span>
  </label>;
}
